<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Adicionar Esporádico' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <ion-grid class="gradient-container">
    <div class="gradient-overlay"></div>

    <ion-row class="ion-justify-content-center">
      <ion-col size="auto">
        <img [src]="pessoa.foto | image:' '" class="image" />
      </ion-col>
    </ion-row>

    <ion-row class="ion-justify-content-center">
      <ion-col size="auto">
        <p class="nome-pessoa bold-2">
          {{pessoa.id ? pessoa.nome : ("Nenhum Esporádico Selecionado" |
          translate)}}
        </p>
      </ion-col>
    </ion-row>

    <ion-row
      class="ion-justify-content-center"
      *ngIf="userProvider.hasConfig(120)"
    >
      <ion-col size="10">
        <div>
          <ion-button
            class="btn-default"
            expand="block"
            (click)="selecionarPessoa();"
          >
            {{'Selecionar Esporádico' | translate}}
          </ion-button>
        </div>
      </ion-col>
    </ion-row>

    <ion-row class="ion-justify-content-center" *ngIf="userProvider.hasConfig(119)">
      <ion-col size="auto">
        <div>
          <p class="criar" (click)="criarVisitante();">
            {{'Criar Esporádico +' | translate}}
          </p>
        </div>
      </ion-col>
    </ion-row>

    <ion-row class="ion-justify-content-center" *ngIf="pessoa.id">
      <ion-col size="10">
        <div>
          <ion-button
            class="btn-success"
            expand="block"
            (click)="salvar(pessoa.id);"
          >
            {{'Salvar' | translate}}
          </ion-button>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
